export type WithdrawalAmountTranslations = {
  navTitle: string;
  minimum: string;
  from: string;
  wallet: string;
  available: string;
  confirm: string;
  percentage25: string;
  percentage50: string;
  percentage75: string;
  percentage100: string;
  errorTooHigh: string;
  errorTooLow: string;
  availableAmountTitle: string;
  availableAmountDescription: string;
};

const withdrawalAmountTranslationKeys: Omit<
  WithdrawalAmountTranslations,
  'wallet'
> = {
  navTitle: 'withdraw_fiat',
  minimum: 'minimum',
  from: 'tx_details_from',
  available: 'available',
  confirm: 'confirm',
  percentage25: 'percentage_25',
  percentage50: 'percentage_50',
  percentage75: 'percentage_75',
  percentage100: 'percentage_100',
  errorTooHigh: 'inline_error_amount_too_high',
  errorTooLow: 'inline_error_amount_too_low',
  availableAmountTitle: 'fiat_available_withdrawal_disclaimer_title',
  availableAmountDescription:
    'fiat_available_withdrawal_disclaimer_description',
};

export const getWithdrawalAmountTranslations = (
  t: (key: string, options?: Record<string, string>) => string,
  currency: string,
): WithdrawalAmountTranslations => ({
  ...(Object.entries(withdrawalAmountTranslationKeys).reduce(
    (acc, [key, value]) => {
      acc[key as keyof typeof withdrawalAmountTranslationKeys] =
        key === 'navTitle' ? t(value, { fiatsymbol: currency }) : t(value);

      return acc;
    },
    {} as Omit<WithdrawalAmountTranslations, 'wallet'>,
  ) as WithdrawalAmountTranslations),
  wallet: t('fiat_wallet_label', { fiatsymbol: currency }),
});
